/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

// export Regions key enum that can be used in client for region specific usecases
export const enum Regions {
  // Dallas
  US_SOUTH = 'us-south',
  // Washington DC
  US_EAST = 'us-east',
  // Sydney
  AU_SYD = 'au-syd',
  // Tokyo
  JP_TOK = 'jp-tok',
  // Frankfurt
  EU_DE = 'eu-de',
  // London
  EU_GB = 'eu-gb'
}

// export aws Regions key enum that can be used in client for region specific usecases
export const enum AWSRegions {
  // Washington DC
  US_EAST_1 = 'us-east-1'
}
